<app-navigation-bar />
<div class="pt-[120px] ">
  <router-outlet />
</div>
